export const english = {
  // Language selection
  language: "Language",
  thai: "Thai",
  english: "English",
  chinese: "Chinese",
  
  // Button labels
  save: "Save",
  saveColumns: "Save Columns",
  search: "Search",
  clear: "Clear",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  cancel: "Cancel",
  ok: "OK",
  close: "Close",
  
  // Column headers and labels commonly used in shipping
  customer: "Customer",
  jobNo: "Job No.",
  containerNo: "Container No.",
  booking: "Booking",
  etd: "ETD",
  eta: "ETA",
  status: "Status",
  invoice: "Invoice",
  shippingProcess: "Shipping Process",
  import: "Import",
  export: "Export",
  
  // Filter labels
  filter: "Filter",
  searchNumber: "Search Number",
  searchValue: "Search Value",
  noFilter: "Not Specified",
  notSpecified: "Not Specified",
  
  // Messages
  saveSuccess: "Columns saved successfully",
  searchRequired: "Please enter at least 1 search condition",
  
  // Shipping specific terms
  blReceived: "B/L Received",
  enterMBL: "Enter M B/L",
  freightInvoice: "Freight Invoice",
  doReceived: "DO Received",
  customsForm: "Draft Customs Form",
  customsClear: "Ready for Clearance",
  
  // Navigation
  jumpToDO: ">>DO Received>>",
  jumpToCustomsClear: ">>Clearance>>",
  jumpToIssue: ">>Issue>>",

  // Shipping column names
  Service: "Service",
  CusAbbr: "Customer Code",
  IP_InvNo: "Invoice No.",
  IP_InvDte: "Invoice Date",
  Bkg: "Booking",
  IP_Csgn: "Consignee",
  IP_ETD: "ETD",
  Note: "Note",
  IP_PO: "PO",
  IP_PoL: "Port of Loading",
  IP_PoD: "Port of Discharge",
  PLCreTm: "PL Received Time",
  OwnAccId: "PL Sender",
  OwnAccNm: "PL Sender",
  OwnAccEmail: "PL Sender Email",
  EDCreTm: "Customs Draft Created",
  EDCreAccId: "Customs Creator",
  EDCreAccNNm: "Customs Creator",
  EDNo: "Customs No.",
  EDAprvTm: "Customs Approved Time",
  EDSndTm: "Customs Sent Time",
  EDCfTm: "Customs Confirmed Time",
  ED0209CreTm: "0209 Created Time",
  ED0209SndTm: "0209 Sent Time",
  ED0309CreTm: "0309 Created Time",
  ED0309SndTm: "0309 Sent Time",
  ED0409CreTm: "0409 Created Time",
  ED0409SndTm: "0409 Sent Time",
  CDCreTm: "Container Declaration Created",
  CDCreAccId: "CD Creator",
  CDCreAccNNm: "CD Creator",
  CDAprvTm: "CD Approved Time",
  CDSndTm: "CD Sent Time",
  PayCstmTm: "Customs Payment Time",
  Rmk: "Remark",
  GrossWt: "G.W.",
  TotalGW: "Total G.W.",
  CT: "Package Count (CT)",
  KGM: "Package Weight (KGM)",
  M3: "Volume (M3)",
  Vol: "Container Count",
  TotalKGM: "VGM WEIGHT",
  ShpTypId: "Vehicle Type",
  Cnee: "Consignee",
  CneeNm: "Consignee",
  CneeSNm: "Consignee",
  BLRecvTm: "B/L Received Time",
  InvPLTm: "Inv/PL Received Time",
  BLCfTm: "HBL Confirmed Time",
  BLSndTm: "HBL Sent Time",
  ANRecvTm: "Notice Received Time",
  MBLRecvTm: "MBL Received Time",
  MBLEntrTm: "MBL Entry Time",
  FrtInvTm: "Freight Invoice Time",
  FrtInvPaidTm: "Freight Paid Time",
  DOMailTm: "DO Mail Sent Time",
  DORecvTm: "DO Received Time",
  CstmFormDfTm: "Customs Draft",
  CstmFormCfTm: "Customs Confirm",
  CstmClrTm: "Clearance Date",
  BLSts: "Work Status",
  DemFreeTm: "Dem Free Time",
  DemStDte: "Dem Start Date",
  DetFreeTm: "Det Free Time",
  DetStDte: "Det Start Date",
  ContNos: "Container Numbers in B/L",
  ContNoStr: "Container Numbers in B/L",
  ManAccNNm: "Shp",
  ManAccNNmCS: "CS",
  ManAccNNmDoc: "Doc",
  ManAccNNmSugg: "Referrer",
  ManAccNNmSale: "Sale",
  ManAccId: "Shp",
  ManAccIdCS: "CS",
  ManAccIdDoc: "Doc",
  ManAccIdSugg: "Referrer",
  ManAccIdSale: "Sale",
  SealContTm: "Container Seal Date",
  ScId: "Hire Shipping",
  FormTm: "Form Time",
  DocSndTm: "Document Sent Time",
  Brnd: "Brand",
  IssuId: "Issue",
  IssuNm: "Issue",
  ShpRunSt: "Departure Time",
  ShpRunEn: "Card Received Time",
  ShpInvServNm: "Service",
  ShpContNos: "Container Numbers in B/L",

  // Issue columns
  Prty: "Priority",
  Clr: "Issue Color",
  IssuTm: "Issue Time",
  Dscp: "Issue Description",
  IsFix: "Fixed",

  // Additional terms
  addInvoice: "Add Invoice",
  linkInvoice: "Link Invoice",
  issueTable: "Issue Table",
  responsible: "Responsible Person",
  hireShipping: "Hire Shipping",
  notHireShipping: "Not Hire Shipping",
  hireShippingStatus: "Hiring Status",
  truckStatus: "Truck Status",
  notNotifiedTruck: "Not Notified Truck",
  truckNotified: "Truck Notified",
  noContainerPicture: "No Container Picture",
  hasContainerPicture: "Has Container Picture",
  noContainerNumber: "No Container Number",
  notArrivedFactory: "Not Arrived Factory",
  shippingStatus: "Shipping Status",
  workNotFinished: "Work Not Finished",
  appointmentDate: "Appointment Date",

  // Additional shipping terms
  truckHead: "Truck Head",
  containerCount: "Container Count",
  truckNotification: "Truck Notification",
  print: "Print",
  notifyCustomer: "Notify Customer",
  gotContainerNumber: "Got Container Number",
  arrivedFactory: "Arrived Factory",
  workCompleted: "Work Completed",
  containerPictures: "Container Pictures",
  sequenceNumber: "Sequence No.",
  files: "Files",
  documentsComplete: "Documents Complete",
  No: "No.",
  RecvDocDte: "Work Received Time",
  IsOwnTuk: "Use CTT Truck",
  notIsOwnTuk: "Don't Use CTT Truck",
}